import { z } from 'zod';
export const platformMediaAcquisitionCapability = 'platform.media-acquisition.v1';
const contentTypeSchema = z.string().trim().min(1).max(120).regex(/^[a-z0-9][a-z0-9!#$&^_.+-]*\/[a-z0-9][a-z0-9!#$&^_.+-]*$/i);
export const platformMediaAcquisitionRequestSchema = z.strictObject({
    moduleId: z.string().trim().min(1).max(80).regex(/^[a-z][a-z0-9-]*$/),
    resourceType: z.string().trim().min(1).max(80).regex(/^[a-z][a-z0-9-]*$/),
    resourceId: z.string().uuid(),
    purpose: z.string().trim().min(1).max(80).regex(/^[a-z][a-z0-9-]*$/),
    mode: z.enum(['still-photo', 'video']),
    acceptedContentTypes: z.array(contentTypeSchema).min(1).max(32).refine((values) => new Set(values).size === values.length, 'Accepted content types must be unique.'),
    maximumFileSizeBytes: z.number().int().positive().max(5_368_709_120),
    idempotencyKey: z.string().uuid(),
    facing: z.enum(['environment', 'user']).optional(),
});
export const platformMediaAcquisitionManifestSchema = z.strictObject({
    schemaVersion: z.literal(1),
    acquisitionId: z.string().uuid(),
    idempotencyKey: z.string().uuid(),
    tenantId: z.string().uuid(),
    actorUserId: z.string().uuid(),
    membershipId: z.string().uuid(),
    sessionRevision: z.number().int().positive(),
    moduleId: z.string(),
    resourceType: z.string(),
    resourceId: z.string().uuid(),
    purpose: z.string(),
    mode: z.enum(['still-photo', 'video']),
    adapter: z.literal('browser-os-capture-input'),
    fileName: z.string().min(1).max(255),
    contentType: contentTypeSchema,
    sizeBytes: z.number().int().nonnegative(),
    selectedAt: z.string().datetime({ offset: true }),
});
//# sourceMappingURL=platform-media-acquisition.contract.js.map